import { useState } from 'react';
import { getFunnelSessionCode } from '../../../utils/session';

interface DemoFormProps {
  onNext: (data: any) => void;
}

export default function DemoForm({ onNext }: DemoFormProps) {
  const [formData, setFormData] = useState({
    adSoyad: '',
    telefon: '',
    firmaAdi: '',
    sektor: '',
    hizmetUrun: '',
    ortalamaFiyat: '',
    gunlukButce: '',
    aylikHedefCiro: '',
    sehir: '',
    instagram: '',
    facebookSayfa: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const payload = {
        step: 'step3',
        oturum_kodu: getFunnelSessionCode(),
        ...formData
      };

      const response = await fetch('/api/funnel_kaydet.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (result.status === 'success') {
        onNext(formData);
      } else {
        alert('Başvuru kaydedilemedi. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      console.error('Form gönderim hatası:', error);
      alert('Sunucu bağlantı hatası oluştu.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section className="min-h-screen flex items-center justify-center py-32 px-4 sm:px-6 lg:px-8 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900 to-black"></div>

      <div className="relative z-10 max-w-4xl mx-auto w-full">
        <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/30 rounded-2xl p-8 sm:p-12 shadow-2xl shadow-yellow-500/10">

          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full mb-4">
              <i className="ri-file-list-3-line text-2xl text-black"></i>
            </div>

            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-3">
              Demo Başvuru Formu
            </h2>

            <p className="text-gray-400">
              Sizin için özel reklam planı hazırlayabilmemiz için detaylı bilgilerinizi paylaşın
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" id="demo-form">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              <div>
                <label className="block text-white font-medium mb-2">Ad Soyad *</label>
                <input
                  type="text"
                  name="adSoyad"
                  value={formData.adSoyad}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                  placeholder="Adınız ve soyadınız"
                />
              </div>

              <div>
                <label className="block text-white font-medium mb-2">Telefon *</label>
                <input
                  type="tel"
                  name="telefon"
                  value={formData.telefon}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                  placeholder="0555 555 55 55"
                />
              </div>

            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              <div>
                <label className="block text-white font-medium mb-2">Firma Adı *</label>
                <input
                  type="text"
                  name="firmaAdi"
                  value={formData.firmaAdi}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                  placeholder="Firma adınız"
                />
              </div>

              <div>
                <label className="block text-white font-medium mb-2">Sektör *</label>
                <input
                  type="text"
                  name="sektor"
                  value={formData.sektor}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                  placeholder="Örn: E-ticaret, Sağlık"
                />
              </div>

            </div>

            <div>
              <label className="block text-white font-medium mb-2">Hizmet veya Ürün *</label>
              <input
                type="text"
                name="hizmetUrun"
                value={formData.hizmetUrun}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                placeholder="Sunduğunuz hizmet veya ürünü açıklayın"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              <div>
                <label className="block text-white font-medium mb-2">Ortalama Ürün Fiyatı *</label>
                <input
                  type="text"
                  name="ortalamaFiyat"
                  value={formData.ortalamaFiyat}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                  placeholder="Örn: 500 TL"
                />
              </div>

              <div>
                <label className="block text-white font-medium mb-2">Günlük Reklam Bütçesi *</label>
                <input
                  type="text"
                  name="gunlukButce"
                  value={formData.gunlukButce}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                  placeholder="Örn: 300 TL"
                />
              </div>

            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              <div>
                <label className="block text-white font-medium mb-2">Aylık Hedef Ciro *</label>
                <input
                  type="text"
                  name="aylikHedefCiro"
                  value={formData.aylikHedefCiro}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                  placeholder="Örn: 100.000 TL"
                />
              </div>

              <div>
                <label className="block text-white font-medium mb-2">Şehir *</label>
                <input
                  type="text"
                  name="sehir"
                  value={formData.sehir}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                  placeholder="Örn: İstanbul"
                />
              </div>

            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              <div>
                <label className="block text-white font-medium mb-2">Instagram</label>
                <input
                  type="text"
                  name="instagram"
                  value={formData.instagram}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                  placeholder="@kullaniciadi"
                />
              </div>

              <div>
                <label className="block text-white font-medium mb-2">Facebook Sayfa Adresi</label>
                <input
                  type="text"
                  name="facebookSayfa"
                  value={formData.facebookSayfa}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-black/50 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500/20"
                  placeholder="https://facebook.com/sayfa"
                />
              </div>

            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full py-4 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black rounded-lg font-bold text-lg hover:shadow-2xl hover:shadow-yellow-500/50 hover:scale-105 transition-all duration-300"
            >
              {isSubmitting ? 'Gönderiliyor...' : 'Başvuruyu Gönder'}
            </button>

          </form>
        </div>
      </div>
    </section>
  );
}